export default "__VITE_ASSET__db7a0bc2__"